import {Component, OnDestroy, OnInit, Input, ViewChild, AfterViewInit, OnChanges, SimpleChanges} from '@angular/core';
import { EventManager } from 'src/app/core';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/core/constant';
import { ValueRange } from './value.range.model';
import { SubscriptionService } from '../../services/subscription.service';
import { NumberUtil } from '../../util/number.util';
declare let $: any;
@Component({
  selector: 'app-input-value-range',
  templateUrl: './input-value-range.component.html',
  styleUrls: ['./input-value-range.component.scss'],
})
export class InputValueRangeComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() relationalOperators: any[] = [];
  @Input() broadcast: string;
  @Input() unit: string;
  @Input() unitValue: string;
  @Input() data: any[] = [];
  @Input() isViewed: boolean = false;
  @Input() isSaved: boolean = false;
  @Input() typeCode: string;
  Constant = Constant;
  firstValueRange: ValueRange = null;
  lastedValueRange: ValueRange = null;
  valueList: any[] = [];
  beginOperators: any = [] = [];
  endOperators: any = [] = [];
  list: any[] = [];
  subscribe: Subscription;
  id: any;
  subscribeState: any;
  errors: any = {};
  constructor(
    private eventManager: EventManager,
  ) {
  }
  ngOnInit() {
    this.subscribeState = SubscriptionService.register(2, this.parseData.bind(this));
    this.id = Math.floor(Math.random() * 10000);
    this.setDefaultValueRange();
    this.subscribe = this.eventManager.subscribe(this.broadcast + '-emit' , (content) => {
      this.emitData();
    });
    this.valueList = this.valueList || [];
    this.setDataList();
  }
  ngOnDestroy() {
    this.subscribe.unsubscribe();
  }
  ngAfterViewInit() {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.relationalOperators && changes.relationalOperators.currentValue && changes.relationalOperators.currentValue.length > 0) {
      this.setRelationalOperators();
    }
    if (changes.data && changes.data.currentValue) {
      this.setDataList();
    }
    if (changes.unitValue && changes.unitValue.currentValue) {
      console.log('unitValue', changes.unitValue.currentValue );
    }
  }
  
  setDefaultValueRange() {
    this.beginOperators = this.beginOperators || [];
    this.endOperators = this.endOperators || [];
    this.list = this.list || [];
  }

  setDataList() {
    this.list = (this.data || []).map((item) => {
      item.beginVolume = parseInt(item.beginValue);
      item.endVolume = parseInt(item.endValue);
      item.keyValue = item.fee;
      return new ValueRange(item);
    });
    if (!this.list.length) {
      const firstValue = new ValueRange();
      firstValue.beginOperatorCode = '>';
      firstValue.endOperatorCode = '<=';
      this.list.push(firstValue);
    }
    if (this.list.length === 1) {
      const lastedValue = new ValueRange();
      lastedValue.beginOperatorCode = '>';
      lastedValue.endOperatorCode = '<=';
      this.list.push(lastedValue);
    }
    this.firstValueRange = this.list[0];
    this.lastedValueRange = this.list[this.list.length - 1];
    setTimeout(() => {
      this.subscribeState.next();
    }, 500)
  }
  setRelationalOperators() {
    this.relationalOperators.forEach((operator) => {
      if (operator.direction === 0) {
        this.beginOperators.push(operator);
      } else {
        this.endOperators.push(operator);
      }
    });
    setTimeout(() => {
      this.subscribeState.next();
    }, 500)
  }
  parseData() {
    this.list.forEach((item) => {
      let findOperator = this.beginOperators.find(ope => ope.code === item.beginOperatorCode);
      if (!findOperator) {
        item.beginOperatorCode = this.beginOperators[0].code;
      } 
      findOperator = this.endOperators.find(ope => ope.code === item.endOperatorCode);
      if (!findOperator) {
        item.endOperatorCode = this.endOperators[0].code;
      }
    });
  }
  addValueRange() {
    this.list = this.list || [];
    const lastedValueRange = this.list[this.list.length - 1];
    lastedValueRange.endVolume = null;
    const beforeValueRange = this.list[this.list.length - 2];
    let valueRange = new ValueRange();
    valueRange.beginVolume = beforeValueRange.endVolume;
    valueRange.beginValue = beforeValueRange.endValue;
    valueRange.typeCode = this.typeCode;
    let operator = this.relationalOperators.find((ope) => ope.code === beforeValueRange.endOperatorCode);
    if (operator) {
      valueRange.beginOperatorCode = operator ? operator.symmetry.code : valueRange.beginOperatorCode;
      valueRange.endOperatorCode = operator ? operator.symmetry.code : valueRange.endOperatorCode;
    }
    lastedValueRange.beginValue = null;
    this.list.splice(this.list.length - 1, 0, valueRange); 
  }
  removeValueRange(index) {
    this.list.splice(index, 1);
    for (let i = index; i < this.list.length - 1; i++) {
      this.list[i + 1].beginValue = this.list[i].endValue;
      const operator = this.relationalOperators.find((ope) => ope.code === this.list[i].endOperatorCode);
      this.list[i + 1].beginOperatorCode = operator.symmetry.code;
    }
  }
  changeOperator(index) {
    const beforeItem = this.list[index];
    const nextItem = this.list[index + 1];
    if (!nextItem) {
      return;
    }
    const operator = this.relationalOperators.find((ope) => ope.code ===  beforeItem.endOperatorCode);
    nextItem.beginOperatorCode = operator.symmetry.code;
  }
  changeValue(index?) {
    const beforeItem = this.list[index];
    const nextItem = this.list[index + 1];
    if (!nextItem) {
      return;
    }
    nextItem.beginVolume = beforeItem.endVolume;
    nextItem.beginValue = beforeItem.endValue = beforeItem.endVolume;
  }
  disabledButton() {
    this.errors.errorList = this.list.some((item, index) => {
      item.errors = {};
      item.errors.beginVolume = NumberUtil.isNull(item.beginVolume);
      if (index !== this.list.length - 1) {
        item.errors.endVolume = !item.endVolume;
        item.errors.small = this.checkSmallThan( item.beginVolume, item.endVolume);
      }
      if (item.errors.beginVolume || item.errors.endVolume || item.errors.small) {
        return true;
      }
      return false;
    })
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  emitData() {
    this.isSaved = true;
    if (this.disabledButton()) {
      return;
    }
    let valueList = this.list.map((item, index) => {
      return {
        beginOperatorCode: item.beginOperatorCode || (index === 0 ? '<' : ''),
        endOperatorCode: item.endOperatorCode || "",
        beginValue: item.beginVolume || 0,
        beginVolume: item.beginVolume || 0,
        endValue: item.endVolume,
        endVolume: item.endVolume,
        fee: item.keyValue,
        typeCode: this.typeCode
      }
    });
    this.eventManager.broadcast({
      name: this.broadcast + '-result',
      content: {
        valueList, 
        broadcast: this.broadcast
      }
    })
    return valueList;
  }
  checkSmallThan(beginVolume, endVolume) {
    return parseInt(endVolume) < parseInt(beginVolume);
  }
}
